import React from "react";
var ThreeDotLoader = function () {
    return (React.createElement("span", { id: "three-dot-loading" },
        React.createElement("span", null, "\u2022"),
        React.createElement("span", null, "\u2022"),
        React.createElement("span", null, "\u2022")));
};
export default ThreeDotLoader;
